export const ADD_STORE_AGENTS_ERROR = 'ADD_STORE_AGENTS_ERROR';
export const ADD_STORE_AGENTS_SUCCESS = 'ADD_STORE_AGENTS_SUCCESS';
export const ADD_STORE_AGENTS_START = 'ADD_STORE_AGENTS_START';
export const CLEAR_ADD_STORE_AGENT = 'CLEAR_ADD_STORE_AGENT';
